<template>
  <file-upload
    ref="fileUpload"
    :multiple="true"
    :drop-directory="true"
    :size="16 * 1024 * 1024"
    @input-file="inputFile">
    <img
      src="~@/assets/img/messenger-picture.svg"
      class="img-responsive d-inline-block"
      height="20px">
  </file-upload>
</template>

<script>
import FileUpload from 'vue-upload-component';
import { mapActions } from 'vuex';
import { getMediaType } from '@/helpers/mediaHelpers';
import randomString from '@/helpers/randomString';

export default {
  name: 'FileUploader',
  components: {
    FileUpload,
  },
  props: {
    conversationId: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions({
      sendMedia: 'chat/sendMedia',
    }),
    inputFile(file) {
      const formData = new FormData();
      const tempSid = randomString();

      formData.append('file', file.file);
      formData.append('temp_sid', tempSid);

      this.$emit('fileSent', {
        temp_sid: tempSid,
        media_type: getMediaType(file.type),
        media_name: file.name,
        // media_type: getMediaType(file.type),
      });

      this.sendMedia({
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationId,
        data: formData,
      });
    },
  },
};
</script>
